import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './testimonial.css';

// Sample testimonial data - replace with your actual testimonials
const testimonialData = [
  {
    id: 1,
    quote: "Sensetech Trading LLC has transformed the way we manage our retail store. Their EAS antennas and POS systems are top-quality, and the installation was quick and seamless. What really impressed us was their after-sales support — responsive, knowledgeable, and always willing to help. Highly recommended for any business looking to upgrade their tech infrastructure!",
    name: "John Wilson",
    location: "Al-Karama"
  },
  {
    id: 2,
    quote: "Excellent service! The team went above and beyond to ensure our needs were met. I would highly recommend their services to anyone looking for quality and reliability.",
    name: "Emma Davis",
    location: "Al-Jaffiliya"
  },
  {
    id: 3,
    quote: "Working with this company has been an absolute pleasure. Their attention to detail and commitment to customer satisfaction is unmatched in the industry.",
    name: "Michael Johnson",
    location: "Za'abeel"
  },
  {
    id: 4,
    quote: "I've been a customer for over three years now, and I can confidently say they provide the best service in the market. Their team is professional, responsive, and always willing to help.",
    name: "Sarah Thompson",
    location: "Al-Mankhool"
  },
  {
    id: 5,
    quote: "The quality of work and level of service provided exceeded all my expectations. I'm extremely satisfied with the results and will definitely be a returning customer.",
    name: "Robert Brown",
    location: "Al-Jaddaf"
  }
];

function Testimonials() {
  const [activeTestimonial, setActiveTestimonial] = useState(0);
  
  // Auto-rotate testimonials
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveTestimonial((prev) => (prev + 1) % testimonialData.length);
    }, 5000); // Change testimonial every 5 seconds
    
    return () => clearInterval(interval);
  }, []);
  
  // Manual navigation
  const goToTestimonial = (index) => {
    setActiveTestimonial(index);
  };
  
  // Previous testimonial
  const prevTestimonial = () => {
    setActiveTestimonial((prev) => 
      prev === 0 ? testimonialData.length - 1 : prev - 1
    );
  };
  
  // Next testimonial
  const nextTestimonial = () => {
    setActiveTestimonial((prev) => 
      (prev + 1) % testimonialData.length
    );
  };

  return (
    <div>
      {/* <!-- testimonials --> */}
      <section className="w3l-clients py-5" id="clients">
        <div className="container py-lg-5 py-md-3">
          <div className="text-center mb-5">
            <h2 className="mb-4 text-white">What Our Customers Say</h2>
            <p className=" text-white">Hear from some of our satisfied clients</p>
          </div>
          
          <div className="testimonial-width position-relative">
            {/* Testimonial Carousel */}
            <div className="testimonial-carousel">
              {testimonialData.map((item, index) => (
                <div 
                  key={item.id} 
                  className={`testimonial-item ${index === activeTestimonial ? 'active' : ''}`}
                  style={{
                    opacity: index === activeTestimonial ? 1 : 0,
                    transform: `translateX(${(index - activeTestimonial) * 100}%)`,
                    position: 'absolute',
                    width: '100%',
                    transition: 'all 0.5s ease'
                  }}
                >
                  <div className="testimonial-content">
                    <div className="testimonial">
                      <blockquote>
                        <i className="fas fa-quote-left"></i>
                        <q>{item.quote}</q>
                      </blockquote>
                      <div className="testi-des">
                        <div className="peopl align-self">
                          <h3>{item.name}</h3>
                          <p className="indentity">{item.location}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            
            {/* Navigation Arrows */}
            <div className="carousel-navigation mt-4">
              <button 
                className="nav-btn prev" 
                onClick={prevTestimonial}
                aria-label="Previous testimonial"
              >
                <i className="fas fa-chevron-left"></i>
              </button>
              
              {/* Dots */}
              <div className="carousel-indicators">
                {testimonialData.map((_, index) => (
                  <button
                    key={index}
                    className={`dot ${index === activeTestimonial ? 'active' : ''}`}
                    onClick={() => goToTestimonial(index)}
                    aria-label={`Go to testimonial ${index + 1}`}
                  ></button>
                ))}
              </div>
              
              <button 
                className="nav-btn next" 
                onClick={nextTestimonial}
                aria-label="Next testimonial"
              >
                <i className="fas fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- //testimonials --> */}
    </div>
  );
}

export default Testimonials;